import { Button, ButtonVariation } from '../../Button/Button';
import { Modal } from '../../Modal';
import { ModalSize } from '../../../utils';

import './SessionTimeoutModal.css';

interface SessionTimeoutModalProps {
  countdownLabel: string;
  isOpen: boolean;
  isSubmitting?: boolean;
  onContinueSession: () => void;
  warningLeadMinutes: number;
  'data-testid'?: string;
}

function SessionTimeoutModal({
  countdownLabel,
  isOpen,
  isSubmitting = false,
  onContinueSession,
  warningLeadMinutes,
  'data-testid': dataTestId,
}: SessionTimeoutModalProps) {
  const baseTestId = dataTestId ?? 'session-timeout-modal';

  return (
    <Modal
      preventDismiss
      className='session-timeout-modal-wrapper'
      data-testid={baseTestId}
      heading='Session timeout warning'
      isOpen={isOpen}
      size={ModalSize.Medium}
      onClose={() => undefined}>
      <div
        className='session-timeout-modal'
        data-testid={`${baseTestId}-content`}>
        <p
          className='session-timeout-modal__description'
          data-testid={`${baseTestId}-description`}>
          Your session will expire soon due to inactivity. Select Continue Session to stay signed in, or you will be
          logged out automatically.
        </p>
        <p
          aria-atomic='true'
          aria-live='polite'
          className='session-timeout-modal__countdown'
          data-testid={`${baseTestId}-countdown`}>
          You will be logged out in {countdownLabel}.
        </p>
        <p
          className='session-timeout-modal__description'
          data-testid={`${baseTestId}-lead-time`}>
          This warning appears {warningLeadMinutes} {warningLeadMinutes === 1 ? 'minute' : 'minutes'} before your
          session expires.
        </p>
        <div
          className='session-timeout-modal__actions'
          data-testid={`${baseTestId}-actions`}>
          <Button
            isAutoWidth
            aria-label='Continue session and stay signed in'
            data-testid={`${baseTestId}-continue`}
            disabled={isSubmitting}
            type='button'
            variation={ButtonVariation.SOLID}
            onClick={onContinueSession}>
            Continue Session
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default SessionTimeoutModal;
